import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    title: "南京城际物流",
    pageCount: 8,
    selected: 0,
    siteInfo:{}
  },
  mutations: {
    setSiteInfoByStore(state, siteInfo) {
      state.siteInfo = siteInfo;
    }
  },
  actions: {},
  modules: {},
});
